const configs = {
  authUrl:
    import.meta.env.VITE_APP_API_URL ||
    'https://gbcrm-prod2.shoppingnetworkmexico.com',
  apiUrl:
    import.meta.env.VITE_APP_API_URL ||
    'https://gbcrm-prod2.shoppingnetworkmexico.com',
  localAppUrl:
    import.meta.env.VITE_LOCAL_APP_URL ||
    'https://gbcrm-prod2.shoppingnetworkmexico.com',
  sentryDomain:
    import.meta.env.VITE_SENTRY_DOMAIN ||
    'https://gbcrm-prod2.shoppingnetworkmexico.com',
  formFillerUrl:
    import.meta.env.VITE_FORM_FILLER_URL ||
    'https://gb-form-filler.shoppingnetworkmexico.com',
  taxCalculationDate:
    import.meta.env.VITE_APP_TAX_CALCULATION_DATE || '2024-02-29 04:00:00',
  satCodeDate: import.meta.env.VITE_APP_SAT_CODE_DATE || '2024-02-29 04:00:00',
  // Set VITE_REDUX_LOG_ENABLED=false in .env to switch off the redux action
  // logger entirely (useful for local dev or to kill it in prod without a
  // redeploy if the backend endpoint goes down).
  reduxLogEnabled: import.meta.env.VITE_REDUX_LOG_ENABLED !== 'false'
}
export default configs
